import { SignIn } from "../components/connection/Auth";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Login() {
    const { t } = useTranslation();
    return (
        <div className="login flex justify-center items-center h-screen">
            <div className="centered-element">
                <SignIn/>
                <div className="text-center mt-4">
                    <Link to="/codeforgetpassword" className="text-blue-500 hover:text-blue-700 font-bold text-xs" >{t('forget_password')}</Link>
                </div>
            </div>
        </div>
    );
}

export default Login;
